export default __webpack_public_path__ + "static/media/i103sp.69471d3b.webp";